<div [formGroup]="parts" class="tel-input-container" [class.floating]="shouldLabelFloat" [id]="id" [attr.aria-describedby]="describedBy">
  <input
    class="tel-input-element"
    formControlName="minutes"
    type="number"
    max="99"
    min="0"
    aria-label="minutes"
    placeholder="min"
    (input)="_handleInput()"
  />
  <span class="tel-input-spacer">:</span>
  <input
    class="tel-input-element"
    formControlName="seconds"
    type="number"
    max="59"
    min="0"
    aria-label="seconden"
    placeholder="sec"
    (input)="_handleInput()"
  />
  <span class="tel-input-spacer">,</span>
  <input
    class="tel-input-element"
    type="number"
    max="99"
    min="0"
    formControlName="milliseconds"
    aria-label="milliseconden"
    placeholder="ms"
    (input)="_handleInput()"
  />
</div>
